import {
  Outlet,
  createRootRoute,
  createRoute,
  createRouter,
} from "@tanstack/react-router";
import { AppLayout } from "./components/AppLayout";
import { LoginPage } from "./pages/Login";
import { CancelAppointmentPage } from "./pages/CancelAppointment";
import { DashboardPage } from "./pages/Dashboard";
import { PatientsPage } from "./pages/Patients";
import { PatientDetailPage } from "./pages/PatientDetail";
import { AppointmentsPage } from "./pages/Appointments";
import { InsightsPage } from "./pages/Insights";
import { ChatPage } from "./pages/Chat";
import { MailPage } from "./pages/Mail";
import { PrescriptionsPage } from "./pages/Prescriptions";
import { AuditPage } from "./pages/Audit";
import { SettingsPage } from "./pages/Settings";

const rootRoute = createRootRoute({ component: () => <Outlet /> });

/* ---------- public routes ---------- */
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

const cancelRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cancel/$token",
  component: CancelAppointmentPage,
});

/* ---------- authenticated shell ---------- */
const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "app",
  component: AppLayout,
});

const dashboardRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: DashboardPage,
});

const patientsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/patients",
  component: PatientsPage,
});

const patientDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/patients/$patientId",
  component: PatientDetailPage,
});

const appointmentsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/appointments",
  component: AppointmentsPage,
});

const insightsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/insights",
  component: InsightsPage,
});

const chatRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/chat",
  component: ChatPage,
});

const mailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/mail",
  component: MailPage,
});

const prescriptionsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/prescriptions",
  component: PrescriptionsPage,
});

const auditRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/audit",
  component: AuditPage,
});

const settingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/settings",
  component: SettingsPage,
});

const routeTree = rootRoute.addChildren([
  loginRoute,
  cancelRoute,
  appRoute.addChildren([
    dashboardRoute,
    insightsRoute,
    patientsRoute,
    patientDetailRoute,
    appointmentsRoute,
    chatRoute,
    mailRoute,
    prescriptionsRoute,
    auditRoute,
    settingsRoute,
  ]),
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
